import { render, staticRenderFns } from "./CustomSelector.vue?vue&type=template&id=1e0e5fd2&scoped=true"
import script from "./CustomSelector.vue?vue&type=script&lang=js"
export * from "./CustomSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e5fd2",
  null
  
)

export default component.exports